// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Degrees$Linear from "lumi-linear/lib/es6/src/Degrees.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Cone(props) {
  let __vectorEffect = props.vectorEffect;
  let __closed = props.closed;
  let __angle = props.angle;
  let edgeLength = props.edgeLength;
  let __orientation = props.orientation;
  let __position = props.position;
  let position = __position !== undefined ? __position : [
      0,
      0
    ];
  let orientation = __orientation !== undefined ? __orientation : [
      1,
      0
    ];
  let angle = __angle !== undefined ? __angle : Degrees$Linear.toRadians(80);
  let closed = __closed !== undefined ? __closed : true;
  let vectorEffect = __vectorEffect !== undefined ? __vectorEffect : "non-scaling-stroke";
  let match = V2f$Linear.mapToString(V2f$Linear.plus(V2f$Linear.rotate(V2f$Linear.scaleTo(orientation, edgeLength), -0.5 * angle), position));
  let c1y = match[1];
  let c1x = match[0];
  let match$1 = V2f$Linear.mapToString(V2f$Linear.plus(V2f$Linear.scaleTo(orientation, edgeLength * 1.4), position));
  let match$2 = V2f$Linear.mapToString(V2f$Linear.plus(V2f$Linear.rotate(V2f$Linear.scaleTo(orientation, edgeLength), 0.5 * angle), position));
  let c2y = match$2[1];
  let c2x = match$2[0];
  let match$3 = V2f$Linear.mapToString(position);
  let py = match$3[1];
  let px = match$3[0];
  let d = closed ? `M ` + c1x + `,` + c1y + ` Q ` + match$1[0] + `,` + match$1[1] + ` ` + c2x + `,` + c2y + ` L ` + px + `,` + py + ` Z` : `M ` + c1x + `,` + c1y + ` L ` + px + `,` + py + ` L ` + c2x + `,` + c2y;
  return JsxRuntime.jsx("path", {
    className: props.className,
    style: props.style,
    d: d,
    vectorEffect: vectorEffect
  });
}

let make = Cone;

export {
  make,
}
/* V2f-Linear Not a pure module */
